export default "__VITE_ASSET__CxWATYQO__"